var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 7.08333L11.4661 15.197L11.4685 15.1991C10.4975 16.4335 9.91667 18 9.91667 19.7045C9.91667 23.6877 13.088 26.9167 17 26.9167C20.912 26.9167 24.0833 23.6877 24.0833 19.7045C24.0833 18 23.5025 16.4335 22.5315 15.1991L22.5339 15.197L17 7.08333ZM18.7708 25.1136C20.7268 25.1136 22.3125 23.4991 22.3125 21.5076C22.3125 19.516 20.7268 17.9015 18.7708 17.9015C16.8148 17.9015 15.2291 19.516 15.2291 21.5076C15.2291 23.4991 16.8148 25.1136 18.7708 25.1136Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 34C26.3889 34 34 26.3888 34 17C34 7.61116 26.3889 0 17 0C7.61112 0 0 7.61116 0 17C0 26.3888 7.61112 34 17 34ZM17 31.1667C24.824 31.1667 31.1667 24.824 31.1667 17C31.1667 9.17596 24.824 2.83333 17 2.83333C9.17599 2.83333 2.83333 9.17596 2.83333 17C2.83333 24.824 9.17599 31.1667 17 31.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/Drop.0ca0d8f923381a7f2897e8b11a3fb27c.svg";
export { ForwardRef as ReactComponent };